<div class="card mb-0">
  <div class="card-body">
    <div class="text-center">
      <img src="../../../../assets/img/Group 40084.png" alt="" height="210" class="mb-3" />
      <h2 class="mb-2">{{ message }}</h2>

      <div class="quiz-results text-dark mb-3 px-3">
        <p>
          You have earned
          <span class="text-primary">{{ percentage > 0 ? '+' + percentage : percentage }} points</span> from the
          assessment
        </p>
        <div class="d-flex justify-content-center mt-3 mb-3">
          <p *ngIf="percentage < 100">Let's redo the questions you got wrong</p>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-3">
      <!-- Show a progress bar with the number of questions answered correctly and the number of questions answered incorrectly -->
      <div class="progress">
        <div class="progress-bar" [style.width]="correctAnswers / quizQuestionCount * 100 + '%'"></div>
        <div class="progress-bar bg-danger"
          [style.width]="(quizQuestionCount - correctAnswers) / quizQuestionCount * 100 + '%'"></div>
      </div>
      <p class="mb-0">
        {{ correctAnswers }} / {{ quizQuestionCount }} Questions
      </p>
    </div>
    <div class="d-flex flex-column">
      <button class="btn btn-primary btn-md" *ngIf="percentage < 100" (click)="retryQuiz()">
        Retry Quiz
      </button>
      <!-- <button class="btn btn-outline-primary btn-md mt-1" (click)="reviewQuiz()">Review the quiz</button> -->
      <button class="btn btn-outline-primary btn-md mt-1" (click)="continueLearning()">
        Continue learning
      </button>
    </div>
  </div>
</div>